<div class="edit-container">
    <h1 class="edit-title">Editare configurare grup</h1>

    <!-- Info grup (readonly) - Full width -->
    <div class="group-info-section mb-4">
        <!-- Modul -->
        <div class="row mb-2">
            <div class="col-12">
                <div class="info-item">
                    <span class="info-label">Modul:</span>
                    <span class="info-value">{{ grupInfo.denumire_modul }}</span>
                </div>
            </div>
        </div>
        <!-- Locație -->
        <div class="row mb-2">
            <div class="col-12">
                <div class="info-item">
                    <span class="info-label">Locație:</span>
                    <span class="info-value">{{ grupInfo.denumire_locatie }}</span>
                </div>
            </div>
        </div>
        <!-- Serviciu -->
        <div class="row">
            <div class="col-12">
                <div class="info-item">
                    <span class="info-label">Serviciu:</span>
                    <span class="info-value">{{ grupInfo.denumire_serviciu }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Zile configurate -->
    <div class="zile-section mb-4">
        <h4 class="section-subtitle">Zile configurate</h4>

        <div class="zile-list">
            <div class="zi-item row align-items-center mb-2" *ngFor="let zi of zile; let i = index">
                <div class="col-4">
                    <span class="zi-name">{{ getNumeZi(zi.day_of_week) }}</span>
                </div>
                <div class="col-5">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Ora</mat-label>
                        <input matInput
                            [(ngModel)]="zi.time_from"
                            [ngxMatTimepicker]="picker"
                            [format]="24"
                            placeholder="HH:MM" />
                        <ngx-mat-timepicker #picker color="primary"></ngx-mat-timepicker>
                    </mat-form-field>
                </div>
                <div class="col-3 text-end">
                    <button type="button" mat-icon-button color="warn" (click)="removeZi(i)"
                        title="Șterge ziua" [disabled]="zile.length <= 1">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>
        </div>

        <!-- Adaugă zi nouă -->
        <div class="add-zi-section mt-3" *ngIf="!showAddZi && zileSaptamanaDisponibile.length > 0">
            <button type="button" mat-stroked-button color="primary" (click)="showAddZi = true">
                <mat-icon>add</mat-icon>
                Adaugă zi
            </button>
        </div>

        <div class="add-zi-form row align-items-center mt-3" *ngIf="showAddZi">
            <div class="col-4">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Zi</mat-label>
                    <mat-select [(ngModel)]="newZi.day_of_week">
                        <mat-option [value]="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let zi of zileSaptamanaDisponibile" [value]="zi.value">
                            {{ zi.key }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-4">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Ora</mat-label>
                    <input matInput
                        [(ngModel)]="newZi.time_from"
                        [ngxMatTimepicker]="newZiPicker"
                        [format]="24"
                        placeholder="HH:MM" />
                    <ngx-mat-timepicker #newZiPicker color="primary"></ngx-mat-timepicker>
                </mat-form-field>
            </div>
            <div class="col-4">
                <button type="button" mat-flat-button color="primary" (click)="addZi()" class="me-2">
                    Adaugă
                </button>
                <button type="button" mat-stroked-button (click)="cancelAddZi()">
                    Anulează
                </button>
            </div>
        </div>

        <div class="no-more-days mt-3" *ngIf="zileSaptamanaDisponibile.length === 0">
            <small class="text-muted">Toate zilele săptămânii sunt deja configurate.</small>
        </div>
    </div>

    <!-- Email comun -->
    <div class="email-section mb-4">
        <mat-form-field class="w-100" appearance="fill">
            <mat-label>Email-uri (pentru toate zilele)</mat-label>
            <input matInput [(ngModel)]="emails" placeholder="email1@ex.com;email2@ex.com">
            <mat-hint>Separate prin ; (punct și virgulă)</mat-hint>
        </mat-form-field>
    </div>

    <!-- Acțiuni -->
    <div class="row">
        <div class="col d-flex justify-content-between">
            <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">
                {{ helper.dialogConfig.buttonLabels.close }}
            </button>
            <button class="buttons" mat-flat-button color="primary" (click)="saveGroup()" [disabled]="isLoading">
                {{ helper.dialogConfig.buttonLabels.save }}
            </button>
        </div>
    </div>

    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>
